var INIT_RECURRING_PAYMENT_SUB_TYPES = ['init_recurring_sale'];

function requiresRecurringCategory() {
  return INIT_RECURRING_PAYMENT_SUB_TYPES.includes($('[id$=\'transaction_payment_subtype\']').val());
}

function toggleRecurringCategory() {
  var $recurringCategorySelect = $('.recurring-category-select');

  if (requiresRecurringCategory()) {
    $recurringCategorySelect.removeClass('hidden');
  } else {
    $recurringCategorySelect.addClass('hidden');
  }
}

function listenForPaymentSubtypeChange() {
  toggleRecurringCategory();
  $('[id$=\'transaction_payment_subtype\']').on('change', function () {
    toggleRecurringCategory();
  });
}

var BaseMobileInitRecurring = {
  listenForPaymentSubtypeChange: listenForPaymentSubtypeChange
};
export default BaseMobileInitRecurring;